import React, { PureComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import config from '../../../../../../../../config'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

const MODULE_NAME = config.modules.portfolio.key

export default class NoBlock extends PureComponent {
    render() {
        return (
            <div className={`workspace-${MODULE_NAME}-noBlock`}>
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
                </div>
                <div className={'subtitle'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.subtitle`} />
                </div>
            </div>
        )
    }
}
